import ParentCss from "../../style.module.scss";

import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { AutoCompleteInput, Input } from "nlib/ui";
import { getCurrentQuickBooksRealmId, getSelectedBusinessData, getUserBusinessesData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import BusinessesActions from "actions/BusinessesActions";
import Button from "nlib/ui/Button";
import Environment from "utils/Environment";
import IntegrationServices from "const/IntegrationServices";
import Intercom from "utils/Intercom";
import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import RoboticActions from "actions/RoboticActions";
import Step from "../Step";
import Texts from "utils/Texts";
import classNames from "classnames";

const InviteUserStep = ({ index, currentStep }) => {
  const dispatch = useDispatch();

  const { messages, uiTexts } = useSelector(getTextsData);

  const quickBooksBusiness = !!useSelector(getCurrentQuickBooksRealmId);

  const businessesData = useSelector(getUserBusinessesData);

  const {
    id: selectedBusinessId,
    name: businessName,
    extraData: {
      integrationService,
      quickBooksAccountantClients: selectedQuickBooksAccountantClients
    } = {}
  } = useSelector(getSelectedBusinessData);

  const availableQuickBooksAccountantClients = useMemo(() => {
    return [...new Set(businessesData
      .filter(({ extraData = {} }) => {
        return !!extraData.quickBooksAccountantClients && extraData.uncategorizedRpaEnabled === true;
      })
      .flatMap(({ extraData }) => extraData.quickBooksAccountantClients || []))]
      .sort((valueA, valueB) => valueA.localeCompare(valueB));
  }, [businessesData]);

  const hasQuickBooksAccountantBusiness = businessesData.some(({ extraData = {} }) => {
    return !!extraData.quickBooksAccountantClients && extraData.uncategorizedRpaEnabled === true;
  });

  const quickBooksAccountantBusiness = quickBooksBusiness && !!selectedQuickBooksAccountantClients;

  const quickBooksClientBusiness = quickBooksBusiness && !quickBooksAccountantBusiness;

  const [fetching, setFetching] = useState(false);

  const [quickBooksAccountantClient, setQuickBooksAccountantClient] = useState({ label: "" });

  const [quickBooksAccountantModeOverride, setQuickBooksAccountantModeOverride] = useState();

  const quickBooksAccountantMode = quickBooksAccountantModeOverride === undefined
    ? hasQuickBooksAccountantBusiness
    : quickBooksAccountantModeOverride;

  const quickBooksAccountantClientSetup = quickBooksClientBusiness
    && quickBooksAccountantMode
    && !!availableQuickBooksAccountantClients.length;

  const connectedQuickBooksAccountantSetup = quickBooksClientBusiness
    && quickBooksAccountantMode
    && hasQuickBooksAccountantBusiness
    && !availableQuickBooksAccountantClients.length;

  const quickBooksAccountantSetup = quickBooksClientBusiness
    && quickBooksAccountantMode
    && !hasQuickBooksAccountantBusiness;

  const directQuickBooksSetup = quickBooksClientBusiness && !quickBooksAccountantMode;

  const integrationServiceData = IntegrationServices.getByValue(integrationService);

  const [
    inviteRoboticTextA,
    inviteRoboticTextB,
    inviteQuickBooksAccountantText
  ] = messages.onboardingInviteUserStep;

  const {
    onboardingInviteRoboticUserAutomaticNote,
    onboardingInviteRoboticUserHelp,
    onboardingInviteRoboticUserLanguageNote
  } = messages;

  const [
    onboardingInviteRoboticUserHelpButton,
    onboardingInviteRoboticUserHelpQuestion,
    onboardingInviteQuickBooksAccountantBusinessHelpQuestion,
    onboardingInviteQuickBooksAccountantClientHelpQuestion,
    onboardingInviteConnectedQuickBooksAccountantClientHelpQuestion,
    onboardingInviteQuickBooksAccountantSetupHelpQuestion
  ] = onboardingInviteRoboticUserHelp;

  const [
    onboardingInviteRoboticUserA,
    onboardingInviteRoboticUserB,
    onboardingInviteRoboticUserC,
    onboardingInviteRoboticUserD
  ] = useMemo(() => {
    if (!integrationServiceData) return ["", ""];

    let [textA, textB, textC, textD] = messages.onboardingInviteRoboticUser;

    textA = integrationServiceData ? Texts.replaceVars(textA, { businessName, service: integrationServiceData.label }) : "";
    textD = integrationServiceData ? Texts.replaceVars(textD, { businessName }) : "";

    return [textA, textB, textC, textD];
  }, [messages, businessName, integrationServiceData]);

  const [
    onboardingInviteQuickBooksAccountantButton,
    onboardingInviteQuickBooksDirectButton,
    onboardingInviteQuickBooksAccountantSetup,
    onboardingInviteQuickBooksAccountantBusiness,
    onboardingInviteConnectedQuickBooksAccountantSetup,
    onboardingInviteQuickBooksAccountantBusinessName,
    onboardingInviteQuickBooksAccountantClientName
  ] = useMemo(() => {
    const [
      button,
      directButton,
      setup,
      business,
      connectedSetup,
      businessNameLabel,
      clientNameLabel
    ] = messages.onboardingInviteQuickBooksAccountant;

    return [
      button,
      directButton,
      Texts.replaceVars(setup, { businessName, addNewBusiness: uiTexts.addNewBusiness }),
      business,
      Texts.replaceVars(connectedSetup, { businessName }),
      businessNameLabel,
      clientNameLabel
    ];
  }, [messages.onboardingInviteQuickBooksAccountant, businessName, uiTexts.addNewBusiness]);

  let onboardingInviteRoboticUserText = [onboardingInviteRoboticUserA, onboardingInviteRoboticUserC].join(" ");

  if (quickBooksBusiness) {
    onboardingInviteRoboticUserText = [onboardingInviteRoboticUserA, onboardingInviteRoboticUserB].join(" ");
  }
  if (quickBooksAccountantBusiness) onboardingInviteRoboticUserText = onboardingInviteQuickBooksAccountantBusiness;
  if (quickBooksAccountantClientSetup) onboardingInviteRoboticUserText = "";
  if (connectedQuickBooksAccountantSetup) {
    onboardingInviteRoboticUserText = onboardingInviteConnectedQuickBooksAccountantSetup;
  }
  if (quickBooksAccountantSetup) {
    onboardingInviteRoboticUserText = onboardingInviteQuickBooksAccountantSetup;
  }

  let onboardingInviteHelpQuestion = onboardingInviteRoboticUserHelpQuestion;

  if (quickBooksAccountantBusiness) {
    onboardingInviteHelpQuestion = onboardingInviteQuickBooksAccountantBusinessHelpQuestion;
  } else if (quickBooksAccountantClientSetup) {
    onboardingInviteHelpQuestion = onboardingInviteQuickBooksAccountantClientHelpQuestion;
  } else if (connectedQuickBooksAccountantSetup) {
    onboardingInviteHelpQuestion = onboardingInviteConnectedQuickBooksAccountantClientHelpQuestion;
  } else if (quickBooksAccountantSetup) {
    onboardingInviteHelpQuestion = onboardingInviteQuickBooksAccountantSetupHelpQuestion;
  }

  const {
    QBO_RPA_USER,
    XERO_RPA_USER
  } = Environment.getProcessEnvVars();

  let titleText = integrationServiceData
    ? Texts.replaceVars(inviteRoboticTextB, { service: integrationServiceData.label })
    : inviteRoboticTextA;

  if (quickBooksAccountantBusiness) titleText = inviteQuickBooksAccountantText;
  useEffect(() => {
    setQuickBooksAccountantClient({ label: "" });
    setQuickBooksAccountantModeOverride(undefined);
  }, [selectedBusinessId]);

  const handleCopyTextClick = useCallback(async({ currentTarget: { textContent } }) => {
    const { clipboard } = window.navigator;

    if (clipboard && clipboard.writeText) {
      await clipboard.writeText(textContent);
      toast.info(uiTexts.copiedToClipboard);
    }
  }, [uiTexts.copiedToClipboard]);

  const handleQuickBooksAccountantClientInputChange = useCallback((value) => {
    setQuickBooksAccountantClient(value?.value ? value : { label: value });
  }, []);

  const handleQuickBooksAccountantModeChange = useCallback(() => {
    setQuickBooksAccountantClient({ label: "" });
    setQuickBooksAccountantModeOverride(!quickBooksAccountantMode);
  }, [quickBooksAccountantMode]);

  const handleHelpButtonClick = useCallback(() => {
    Intercom.startConversation(Texts.replaceVars(onboardingInviteHelpQuestion, {
      businessName,
      service: integrationServiceData.label
    }));
  }, [businessName, integrationServiceData, onboardingInviteHelpQuestion]);

  const handleButtonClick = useCallback(async() => {
    setFetching(true);
    await dispatch(RoboticActions.setQuickBooksAccountantClientName(selectedBusinessId, quickBooksAccountantClient.value));
    await dispatch(BusinessesActions.fetchBusiness(selectedBusinessId, true, true));
    setFetching(false);
  }, [selectedBusinessId, quickBooksAccountantClient, dispatch]);

  return (
    <Step
      number={index + 1}
      className={classNames(ParentCss.stepFourth, Css.step)}
      active={currentStep === index}
      success={currentStep > index}>
      <div className={ParentCss.row}>
        <div className={ParentCss.col}>
          <div className={ParentCss.subtitle}>
            {titleText}
          </div>
          {currentStep === index && (
            <div className={classNames(ParentCss.text, Css.text)}>
              {onboardingInviteRoboticUserText
                && onboardingInviteRoboticUserText.split("\n\n").map((paragraph) => {
                  return (
                    <div key={paragraph}>
                      {paragraph.split("#").map((string) => {
                        switch (string) {
                          case "email":
                            return (
                              <span key={string} className={ParentCss.copy} onClick={handleCopyTextClick}>
                                <span>{quickBooksBusiness ? QBO_RPA_USER : XERO_RPA_USER}</span>
                                <Icons.Copy />
                              </span>
                            );
                          default:
                            return string.split("*").map((substr, idx) => {
                              return (
                                <Fragment key={String(idx + 1)}>
                                  {idx % "2" ? <b>{substr}</b> : <span>{substr}</span>}
                                </Fragment>
                              );
                            });
                        }
                      })}
                    </div>
                  );
                })}
              {(!quickBooksBusiness
                || quickBooksAccountantBusiness
                || directQuickBooksSetup) && (
                <div>
                  {onboardingInviteRoboticUserAutomaticNote.split("*").map((substr, idx) => {
                    return (
                      <Fragment key={String(idx + 1)}>
                        {idx % "2" ? <b>{substr}</b> : <span>{substr}</span>}
                      </Fragment>
                    );
                  })}
                </div>
              )}
              {quickBooksAccountantClientSetup && (
                <Fragment>
                  {onboardingInviteRoboticUserD.split("\n\n").map((paragraph) => {
                    return (
                      <div key={paragraph}>
                        {paragraph.split("*").map((substr, idx) => {
                          return (
                            <Fragment key={String(idx + 1)}>
                              {idx % "2" ? <b>{substr}</b> : <span>{substr}</span>}
                            </Fragment>
                          );
                        })}
                      </div>
                    );
                  })}
                  <div className={Css.clientMapping}>
                    <div>
                      <div className={Css.clientMappingLabel}>
                        {onboardingInviteQuickBooksAccountantBusinessName}
                      </div>
                      <Input
                        readOnly
                        aria-label={onboardingInviteQuickBooksAccountantBusinessName}
                        title={businessName}
                        value={businessName} />
                    </div>
                    <Icons.ArrowRight />
                    <div>
                      <div className={Css.clientMappingLabel}>
                        {onboardingInviteQuickBooksAccountantClientName}
                      </div>
                      <AutoCompleteInput
                        aria-label={onboardingInviteQuickBooksAccountantClientName}
                        invalid={quickBooksAccountantClient.label && !quickBooksAccountantClient.value}
                        valid={quickBooksAccountantClient.value}
                        placeholder={uiTexts.selectClient}
                        value={quickBooksAccountantClient.label}
                        disabled={fetching}
                        items={availableQuickBooksAccountantClients.map((value) => ({ value, label: value }))}
                        onChange={handleQuickBooksAccountantClientInputChange}
                        onAutoComplete={handleQuickBooksAccountantClientInputChange} />
                    </div>
                  </div>
                </Fragment>
              )}
              {quickBooksBusiness && (
                <div className={Css.languageNote}>
                  <div>
                    {onboardingInviteRoboticUserLanguageNote.split("*").map((substr, idx) => {
                      return (
                        <Fragment key={String(idx + 1)}>
                          {idx % "2" ? <b>{substr}</b> : <span>{substr}</span>}
                        </Fragment>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
          {currentStep === index
            && (quickBooksClientBusiness
              || (window.Intercom && integrationServiceData)) && (
            <div className={ParentCss.buttons}>
              {quickBooksClientBusiness && (
                <Button
                  outline large
                  className={Css.modeButton}
                  onClick={handleQuickBooksAccountantModeChange}>
                  {quickBooksAccountantMode
                    ? onboardingInviteQuickBooksDirectButton
                    : onboardingInviteQuickBooksAccountantButton}
                </Button>
              )}
              {window.Intercom && integrationServiceData && (
                <Button
                  outline large block
                  className={classNames(ParentCss.likeButton, Css.helpButton)}
                  onClick={handleHelpButtonClick}>
                  {onboardingInviteRoboticUserHelpButton}
                </Button>
              )}
              {quickBooksAccountantClientSetup && quickBooksAccountantClient.value && (
                <Button
                  primary large
                  loading={fetching}
                  className={ParentCss.likeButton}
                  onClick={handleButtonClick}>
                  {uiTexts.continue}
                </Button>
              )}
            </div>
          )}
        </div>
        {currentStep > index && (
          <div className={`${ParentCss.likeButton} ${ParentCss.success}`}>
            <Icons.Check weight="bold" />
            <span>{uiTexts.invited}</span>
          </div>
        )}
      </div>
    </Step>
  );
};

export default React.memo(InviteUserStep);
